<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :footer-props="{
        'items-per-page-text':'Linhas por página',
        'page-text': '{0}-{1} de {2}',
        'items-per-page-all-text': 'Todos',
      }"
      class="elevation-1"
      no-data-text="Nenhum template de email adicionado"
    >
      <template #[`item.nome`]="{ item }">
        <router-link
          :to="{ name: 'templates-email-detalhe', params: { id: item.id } }"
          class="text--primary text-truncate cursor-pointer text-decoration-none"
        >
          <div class="d-flex align-center">
            <v-avatar
              :color="`${$vuetify.theme.dark ? 'primary' : '#DCDCDC'}`"
              size="32"
            >
              <span
                :class="`${$vuetify.theme.dark ? 'white--text' : 'primary--text'} font-weight-bold
                  `"
              >
                {{ item.nome.toUpperCase().charAt(0) }}{{ item.nome.toUpperCase().charAt(1) }}
              </span>
            </v-avatar>
            <div class="ms-3 text-capitalize">
              <router-link
                :to="{ name: 'templates-email-detalhe', params: { id: item.id } }"
              ></router-link>
              {{ item.nome }}
            </div>
          </div>
        </router-link>
      </template>

      <template #[`item.ativo`]="{ item }">
        <v-chip
          class="v-chip-light-bg font-weight-semibold text-capitalize"
          small
          :class="`${item.ativo ? 'success--text' : 'secondary--text'}`"
          :color="`${item.ativo ? 'success' : 'secondary'}`"
        >
          {{ item.ativo ? 'Ativo' : 'Inativo' }}
        </v-chip>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              class="ml-n5"
              v-on="on"
              color="primary"
            >
              <v-icon @click="ativarOuInativarItem(item)">
                {{ icons.mdiDotsVertical }}
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title
                role="button"
                class="d-flex"
                @click="openDialogAtivarOuInativarItem"
              >
                <v-icon
                  size="20"
                  class="mr-1"
                >
                  {{ isFormularioAtivo ? icons.mdiCloseThick : icons.mdiCheckBold }}
                </v-icon>
                <span class="text-capitalize">{{ isFormularioAtivoMensagem }}</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

    <!-- dialog -->
    <v-dialog
      v-model="dialogAtivarOuInativarItem"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title class="headline text-capitalize">
          {{ isFormularioAtivoMensagem }}
        </v-card-title>
        <v-card-text>
          {{ `Tem certeza que vai ${isFormularioAtivoMensagem} esse template de email?` }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            outlined
            @click="closeDialogAtivarOuInativarItem"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            @click="confirmarAtivacaoOuInativacaoItem"
          >
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="secondary"
            ></v-progress-circular>
            <span v-else>OK</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mdiCheckBold, mdiCloseThick, mdiDotsVertical } from '@mdi/js'
import { ref } from '@vue/composition-api'
import TemplateEmailService from '@/services/modules/TemplateEmailService'

export default {
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    headers: {
      type: Array,
      default: () => {},
    },
  },

  setup(props, { emit }) {
    const dialogAtivarOuInativarItem = ref(false)
    const loading = ref(false)
    const templateEmailId = ref(0)
    const isFormularioAtivo = ref(undefined)
    const isFormularioAtivoMensagem = ref('')

    const ativarOuInativarItem = item => {
      templateEmailId.value = item.id
      isFormularioAtivo.value = item.ativo
      isFormularioAtivoMensagem.value = item.ativo ? 'inativar' : 'ativar'
    }
    const openDialogAtivarOuInativarItem = () => {
      dialogAtivarOuInativarItem.value = true
    }
    const closeDialogAtivarOuInativarItem = () => {
      dialogAtivarOuInativarItem.value = false
    }
    const confirmarAtivacaoOuInativacaoItem = async () => {
      try {
        loading.value = true
        await TemplateEmailService.ativarOuInativar(templateEmailId.value, {
          ativar: !isFormularioAtivo.value,
        })
        emit('confirmar-ativacao-inativacao')
      } finally {
        closeDialogAtivarOuInativarItem()
        loading.value = false
      }
    }

    return {
      dialogAtivarOuInativarItem,
      loading,
      isFormularioAtivo,
      isFormularioAtivoMensagem,
      ativarOuInativarItem,
      openDialogAtivarOuInativarItem,
      closeDialogAtivarOuInativarItem,
      confirmarAtivacaoOuInativacaoItem,
      icons: {
        mdiCheckBold,
        mdiCloseThick,
        mdiDotsVertical,
      },
    }
  },
}
</script>
